<section *ngIf="!isOpened">
  <div class="row">
    <form class="needs-validation container-style" novalidate [formGroup]="formArticleGeneric">
      <div class="ps-2 pe-2">
        <div class="row pt-1">
          <div class="col">
            <app-custom-button [title]="'Regresar'" [icon]="'pi pi-arrow-left'" [link]="true" [label]="'Regresar'"
              [width]="'6rem'" [routerLink]="['/', url]" [severity]="null"></app-custom-button>
          </div>
          <div class="col d-flex justify-content-sm-center justify-content-end align-items-center">
            <app-navigation (buttonClick)="getButtonClick($event)"></app-navigation>
          </div>

          <div class="col mt-2 mt-sm-0 gap-1 d-flex justify-content-md-end justify-content-center">
            <app-custom-button [title]="'Eliminar Artículo'" [icon]="'pi pi-trash'" [severity]="'contrast'"
              (onClick)="delete()"></app-custom-button>

            <app-custom-button [title]="'Nuevo'" [label]="'Nuevo'" [icon]="'pi pi-plus'" [severity]="'success'"
              [width]="'5.5rem'" [variant]="undefined" (onClick)="createNewRegister()"></app-custom-button>
          </div>
          <hr class="my-1">
        </div>
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12 col-12">
            <app-custom-audit-info [userNameCreate]="articleGenericContract.userNameCreate"
              [createDate]="articleGenericContract.createDate" [userNameUpdate]="articleGenericContract.userNameUpdate"
              [updateDate]="articleGenericContract.updateDate" [reserveSpace]="true"></app-custom-audit-info>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12 col-12">
          <div class="row">
            <div class="col-lg-1 col-md-2 col-sm-2 col-12">
              <app-custom-input-number formControlName="code" [labelText]="'Código'" [required]="true" [recovery]="true"
                (onChangeNumber)="changeArticleGeneric($event)"></app-custom-input-number>
            </div>
            <div class="col-lg-1 col-md-2 col-sm-2 col-12">
              <app-custom-input-text formControlName="alterCode" [labelText]="'Cód. Alterno'"
                [maxLength]="20"></app-custom-input-text>
            </div>
            <div class="col-lg-1 col-md-2 col-sm-2 col-12">
              <app-custom-input-text formControlName="alterCode2" [labelText]="'Cód. Alterno2'"
                [maxLength]="20"></app-custom-input-text>
            </div>
            <div class="col-lg-2 col-md-3 col-sm-3 col-12">
              <app-custom-select formControlName="typeArticleId" [labelText]="'Tipo Artículo'" [list]="listTypeArticle"
                [required]="true" (onChangeSelect)="changeTypeArticleId($event)">
              </app-custom-select>
            </div>
            <div class="col-lg-2 col-md-3 col-sm-3 col-12">
              <app-custom-select formControlName="typeInventoryId" [labelText]="'Tipo Inventario'"
                [list]="listTypeInventory" [required]="true"></app-custom-select>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-6 col-12">
              <app-custom-input-text formControlName="name" [labelText]="'Nombre'" [required]="true"
                (onChangeTextOnBlur)="getArticleGenericByName($event)" [maxLength]="300"></app-custom-input-text>
            </div>
            <div class="col-xl-1 col-lg-1 col-md-2 col-sm-2 col-10">
              <app-custom-tag [label]="'Estado'" [severity]="severityState" [value]="stateArticle">
              </app-custom-tag>
            </div>
            <div class="col field-button">
              <app-custom-button [title]="titleState" [icon]="'pi pi-undo'" [severity]="'primary'"
                (onClick)="changeStateArticle()">
              </app-custom-button>
            </div>
            <div class="row">
              <div class="col-lg-2 col-md-4 col-sm-3 col-12">
                <app-custom-select formControlName="familyId" [labelText]="'Familia'" [list]="listFamily"
                  [required]="true"></app-custom-select>
              </div>
              <div class="col-lg-2 col-md-4 col-sm-3 col-12">
                <app-custom-select formControlName="subgroupId" [labelText]="'Subgrupo'" [list]="listSubgroup"
                  [required]="true" (onChangeSelect)="getSubgroup($event)"></app-custom-select>
              </div>
              <div class="col-lg-2 col-md-4 col-sm-3 col-12">
                <app-custom-select formControlName="groupId" [labelText]="'Grupo'" [list]="listGroup"
                  [required]="true"></app-custom-select>
              </div>
              <div class="col-xl-1 col-lg-2 col-md-3 col-sm-3 col-12">
                <app-custom-select formControlName="rentalUnitId" [labelText]="'Und.Med.Alq.'" [list]="listRentalUnit"
                  [required]="true"></app-custom-select>
              </div>
              <div class="col-xl-1 col-lg-2 col-md-3 col-sm-3 col-12">
                <app-custom-select formControlName="inventoryUnitId" [labelText]="'Und.Med.Inv.'"
                  [list]="listInventoryUnit" [required]="true"></app-custom-select>
              </div>
              <div class="col-xl-1 col-lg-2 col-md-3 col-sm-4 col-12">
                <app-custom-input-decimal formControlName="replacementValue" [labelText]="'Vr.Reposición'"
                  [required]="true">
                </app-custom-input-decimal>
              </div>
              <div class="col-xl-1 col-lg-2 col-md-3 col-sm-4 col-12">
                <app-custom-input-decimal formControlName="saleValue" [labelText]="'Vr.Venta'" [required]="true">
                </app-custom-input-decimal>
              </div>
              <div class="col-md-2 col-12 d-flex align-items-end mt-1">
                <app-custom-button [title]="'Guardar'" [label]="'Guardar'" [severity]="'primary'" [variant]="undefined"
                  [disabled]="disabledForm" (onClick)="send()">
                </app-custom-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</section>
<!-- Mensaje de duplicidad ventanas abiertas -->
<div class="container-form d-flex flex-row text-danger" *ngIf="isOpened">
  <span class="material-icons me-1"> highlight_off </span>
  <h6>No se permite tener dos ventanas/pestañas de {{nameWindow}} abiertas.</h6>
</div>